<template>
  <button
    class="stk-icon is-button"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <i :class="icon" />
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'fas fa-chevron-down',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.stk-icon.is-button {
  cursor: pointer;
  color: var(--stk-primary);
}
</style>
